export const capitalize = string => {
    if (typeof string !== 'string') return ''

    return string.replace(/\w\S*/g, (txt) =>
        txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
}

export const toPascalCase = str => {
    return str
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .split(/[\s_-]/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('')
  }